import React, { Component, useContext, useEffect, useState } from "react";
import "./FishbowlDownloadShipmentsModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../../models/ISupplierModel";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IUserUI from "../../../../models/IUserUI";
import OwDateInput from "../../../shared/OwDateInput/OwDateInput";
import { Moment } from "moment";
import IFishbowlDownloadShipmentsDTO from "../../../../models/DTO/IFishbowlDownloadShipmentsDTO";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IFishbowlOnDownloadShipmentsDTO from "../../../../models/DTO/IFishbowlOnDownloadShipmentsDTO";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const FishbowlDownloadShipmentsModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [fromDate, setFromDate] = useState<Moment>();

    useEffect(() => {
        props.socket.on(EndpointsEnum.FishbowlOnDownloadShipmentsCsv, onDownloadShipments);

        return () => {
            props.socket.removeListener(EndpointsEnum.FishbowlOnDownloadShipmentsCsv, onDownloadShipments);
        };
    }, []);

    const closeModal = () => {
        props.closeModalFn();
    };

    const handleChange = (date: Moment) => {
        setFromDate(date);
    };

    const downloadShipments = () => {
        if (fromDate) {
            const payload: IFishbowlDownloadShipmentsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                fromDate: fromDate?.format("YYYY-MM-DD"),
            };

            props.socket.emit(EndpointsEnum.FishbowlDownloadShipmentsCsv, payload);
        }
    };

    const onDownloadShipments = (data: IFishbowlOnDownloadShipmentsDTO) => {
        downloadCsvData(data.csvData, data.filename);
    };

    const downloadCsvData = (csvData: any, filename: string) => {
        const blob = new Blob([csvData], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = filename;
        link.click();
    };

    const startDownload = () => {
        downloadShipments();
    };

    return (
        <div className={"FishbowlDownloadShipmentsModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cloud-download-alt"} title={"download_shipments"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div className={"mb-2 mt-2"}>
                    <OwLabel title={"from_date"} />
                    <OwDateInput fn={handleChange} />
                </div>

                <div className="mb-2">
                    <OwButton title={"start"} fn={startDownload} />
                </div>
            </div>
        </div>
    );
};
